import { Children } from 'react';

/**
 * Returns the active tab index if the activeTab prop is a string
 * Returns the index itself if the activeTab prop is a number
 * Returns 0 if the activeTab prop is invalid
 *
 * @param {Object[]} children - Array of React children
 * @param {(number|string)} activeTab - An index or name of the active tab
 *
 * @returns {number}
 */
export const getActiveTabIndex = ((children, activeTab) => {
    switch (typeof activeTab) {
        case 'string':
            return Children
                .toArray(children)
                .findIndex((child) => child.props.name === activeTab)
                || 0;
        case 'number':
            const childrenCount = Children.count(children);
            return Math.max(0, Math.min(childrenCount, activeTab));
        default:
            return 0;
    }
});
